import { ImageShapeType } from '../../interfaces';
import { getAggregatedTitleImage } from '../../queries/ats/common';
import type { Asset, SeriesAsset } from '../../queries/ats/titles/types/asset';
import type { ProgramSource } from '../../queries/ats/titles/types/sources';
import { details } from '../../routes/routes';

interface UseDetailsImageOptions {
  asset: Asset;
  shape: ImageShapeType;
  width: number;
}

export function useDetailsImage({ asset, shape, width }: UseDetailsImageOptions) {
  const image = getAggregatedTitleImage(asset.masterId, shape, width);
  return details.isRecording(asset) ? getRecordingImage(asset) ?? image : image;
}

function getRecordingImage(asset: Asset) {
  if (asset.type === 'series') {
    const episode = asset.episodes.find(findProgramSourceRecordingImage);
    return episode ? findProgramSourceRecordingImage(episode) : undefined;
  }

  return findProgramSourceRecordingImage(asset);
}

function findProgramSourceRecordingImage(asset: Exclude<Asset, SeriesAsset>): string | undefined {
  const source = asset.sources.find((src): src is ProgramSource => src.type === 'program');
  return source?.recordings[0]?.image;
}
